// Shared helpers for the WhatsApp chat — kept out of the components so the
// conversation list and the thread describe a message the same way.

const MEDIA_LABELS = {
  image: '📷 Photo', video: '🎥 Video', audio: '🎤 Voice message', document: '📄 Document',
  sticker: 'Sticker', location: '📍 Location', contacts: '👤 Contact', reaction: 'Reaction',
  order: '🛒 Order', interactive: 'Reply', button: 'Reply', unsupported: 'Unsupported message',
  system: 'System message', unknown: 'Message',
};

// One-line summary of a message for the conversation list.
export function previewText(msg) {
  if (!msg) return '';
  if (msg.messageType === 'template') return `📋 ${msg.messageText || msg.templateName || 'Template'}`;
  if (msg.messageText) return msg.messageText;
  if (msg.messageType === 'reaction') return `Reacted ${msg.metadata?.reaction?.emoji || ''}`.trim();
  return MEDIA_LABELS[msg.messageType] || `[${msg.messageType}]`;
}

// Plain-English reasons for the Meta delivery error codes agents actually hit.
const ERROR_HELP = {
  131026: 'The number is not on WhatsApp, or the customer blocked messages.',
  131047: 'The 24-hour window closed — send an approved template instead.',
  131048: 'Meta paused sending because of a high spam-report rate.',
  131049: 'Meta chose not to deliver this marketing message to protect customer experience.',
  131051: 'Unsupported message type.',
  131053: 'The attached media could not be downloaded or is unsupported.',
  131056: 'Too many messages to this number in a short time — try again later.',
  132000: 'The number of variables does not match the template.',
  132001: 'The template does not exist or is not approved in this language.',
  132005: 'The filled-in template text is too long.',
  132007: 'The filled-in template text breaks WhatsApp content policy.',
  132012: 'A variable value is in the wrong format.',
  132015: 'This template is paused by Meta because of low quality.',
  132016: 'This template has been disabled by Meta.',
};

export function failureReason(msg) {
  const code = msg.error?.code;
  return {
    code,
    help: ERROR_HELP[code] || null,
    detail: msg.error?.message || null,
  };
}

// {{1}}, {{2}} … in a template body, in order of first appearance.
export function bodyVariables(text = '') {
  const found = [];
  text.replace(/\{\{\s*(\w+)\s*\}\}/g, (_, key) => { if (!found.includes(key)) found.push(key); return ''; });
  return found;
}
